import type { PropsWithChildren } from 'preact/compat';
import './Badge.less';

export type BadgeProps = PropsWithChildren<{
    className?: string;
}>;

const Badge = ({ className = '', children }: BadgeProps) => (
    <span className={`bri-Badge bri-BodySmallFont ${className}`}>
        {children}
    </span>
);

export default Badge;
